import React from "react";
import { observer } from "mobx-react-lite";
import NotesWidget from "../../api/NotesWidget";
import { truncateReminderText } from "../../utils/notesReminderUtils";
import { BtnOutlineV4 } from "../UI/button/BtnOutlineV4";
import { BtnPrimaryv4 } from "../UI/button/BtnPrimaryv4";

export const NoteReminderToasts = observer(() => {
  const { enabled, activeReminderToasts, notes } = NotesWidget;

  if (!enabled || activeReminderToasts.length === 0) {
    return null;
  }

  return (
    <div
      className="note-reminder-toasts"
      aria-live="polite"
      aria-label="Напоминания по заметкам"
    >
      {activeReminderToasts.map((noteId) => {
        const note = notes.find((n) => n.id === noteId);
        if (!note) {
          return null;
        }
        return (
          <article
            key={noteId}
            className="note-reminder-toast card company-card-v4"
            aria-labelledby={`note-reminder-title-${noteId}`}
          >
            <header className="note-reminder-toast__header">
              <h2
                id={`note-reminder-title-${noteId}`}
                className="note-reminder-toast__title"
              >
                Напоминание
              </h2>
              <button
                type="button"
                className="note-reminder-toast__close"
                aria-label="Закрыть напоминание"
                onClick={() => NotesWidget.dismissReminder(noteId)}
              >
                ×
              </button>
            </header>
            <p className="note-reminder-toast__text">
              {truncateReminderText(note.text)}
            </p>
            <footer className="note-reminder-toast__actions">
              <BtnPrimaryv4
                footerSize
                text="Открыть заметку"
                onClick={() => NotesWidget.openReminderNote(noteId)}
              />
              <BtnOutlineV4
                text="Отложить 10 мин"
                onClick={() => NotesWidget.snoozeReminder(noteId)}
              />
            </footer>
          </article>
        );
      })}
    </div>
  );
});
